// utils
import React, { useEffect, useState } from "react";
import {useMatch, Link, useLocation, useParams} from "react-router-dom";
import axios from "axios";
import { Container, Row, Col } from "react-bootstrap";

// custom utils
import { getCurrentLanguage, getUrlPrefix, LANGUAGES } from "../../../utils/langUtils";
import { globalLoading } from "../../../components/global";
import { determineColor } from "../components/blogColor";

// translations
import translation_cs from "./lang/cs.json";
import translation_en from "./lang/en.json";
import translation_de from "./lang/de.json";

// components
import BlogOlderStart from "../home/components/blog-older-start/blog-older-start";
import BlogOlderEnd from "../home/components/blog-older-end/blog-older-end";

// section
import SectionLoadingError from "../../../components/section-loading-error/section-loading-error";

// storage for DATA obtained from backend
let taggedArticles: any = null;
let requestErrorCode = "";
let requestErrorText = "";



/**
 * TAG page - shows all articles with clicked TAG
 * @params gets clicked TAG with LANGUAGE and REQUESTS all articles with this from backend
 * @returns TAG page
 */
export default function Tag() {

    /**
     * sets ARTICLE container height so without content it has at least the height required to force FOOTER to be on the bottom of the screen viewport not right bellow latest article with grey backgound covering the rest of the PAGE
     */
    function articleContainerHeight() {
        // inner window height - our reference point
        let windowHeight = window.innerHeight;
        let articleContainer = document.getElementById("articleContainer");

        // page header height - this needs to be substracted from WINDOW height
        let tagHeader = document.getElementById("tagHeader");
        let tagHeaderHeight = tagHeader?.offsetHeight;
        
        // footer height - this also needs to be substracted from WINDOW height
        let footer = document.getElementById("footer");
        let footerHeight = footer?.offsetHeight;

        // total height to be substracted form WINDOW height
        let totalHeight = 0
        if(tagHeaderHeight && footerHeight) {
            totalHeight = tagHeaderHeight + footerHeight;
        }

        // our final
        if(articleContainer !== null) {
            articleContainer.style.minHeight = String(windowHeight - totalHeight) + "px";
        }     
    };

    useEffect(() => {
        articleContainerHeight();
    })
    window.addEventListener("resize", (event) => {
        articleContainerHeight();
    });

    // to get ARTICLE URL from parameter in URL query
    let queryString = window.location.search;

    // the URL that needs to be requested from INTERNAL SYSTEM via our SERVER
    const { tag } = useParams();

    const [isLoaded, setIsLoaded] = useState(false);
    const [requestError, setRequestError] = useState(false);


    // used for activating useEffect in a situaction when user clicks on TAG on this PAGE
    const location = useLocation()
    
    /** On PAGE load DATA from backend are REQUESTED 
     * [location] is responsible for page reload when user clicks on TAG on this page => corresponding BLOGs are loaded
    */
    useEffect(() => {
        
        // Sets GLOBAL LOADING to TRUE
        globalLoading.switch();
         
        axios.get("/api/blog/getTag", { params: { lang: language, tag: tag }, timeout: 10000 })
            .then(function (response) {
                taggedArticles = response.data.data;
                // DEBUG
                //console.log(taggedArticles);
                // TODO - simulates waiting for DATA - used for DEBUGGING purposes
                //window.setTimeout(() => {globalLoading.switch();}, 5000);
                
                // Sets GLOBAL LOADING to FALSE
                globalLoading.switch();
                setIsLoaded(true);
    
            })
            .catch(function (error) {
                // Sets GLOBAL LOADING to FALSE
                globalLoading.switch();

                // DEBUG whole error message
                //console.log(error);
                
                // error response from backend
                if(error?.response?.status >= 400 && error?.response?.status <= 599)
                {
                    console.log("status err:", error.response.status, error.response.statusText);
                    requestErrorCode = error.response.status.toString();
                    requestErrorText = error.response.statusText.toString();
                }
                // response from backend timeout
                else
                {
                    console.log("status err: 408 Request Timeout");
                    requestErrorCode = "408";
                    requestErrorText = "Request Timeout";
                }
                setRequestError(true);
                console.log(requestError);
            });
    }, [location])

    const match = useMatch("/:lang/*");
    let lang = (match && match.params.lang) ? match.params.lang : "";

    let translation= translation_cs;

    let language = getCurrentLanguage(lang);
    switch (language) {
        case LANGUAGES.Czech:
            translation = translation_cs;
            break;
        case LANGUAGES.English:
            translation = translation_en;
            break;
        case LANGUAGES.German:
            translation = translation_de;
            break;
    }
    
    /**
     * sets Error container height so without content it has at least the height required to force FOOTER to be on the bottom of the screen viewport not right bellow latest article with grey backgound covering the rest of the PAGE
     */
    function article404ContainerHeight() {
        // inner window height - our reference point
        let windowHeight = window.innerHeight;
        let page404Container = document.getElementById("page404Container");

        // page header height - this needs to be substracted from WINDOW height
        //let tagHeader = document.getElementById("tagHeader");
        //let tagHeaderHeight = tagHeader?.offsetHeight;
        
        // footer height - this also needs to be substracted from WINDOW height
        let footer = document.getElementById("footer");
        let footerHeight = footer?.offsetHeight;

        // total height to be substracted form WINDOW height
        let totalHeight = 0
        if(footerHeight) {
            totalHeight = footerHeight;
        }

        // our final
        if(page404Container !== null) {
            page404Container.style.height = String(windowHeight - totalHeight) + "px";
        }     
    }
    
    useEffect(() => {
        article404ContainerHeight();
    })
    window.addEventListener("resize", (event) => {
        article404ContainerHeight();
    });

    return (
        <>  
            <div>
                { requestError ? 
                    <>
                        <SectionLoadingError requestErrorCode={requestErrorCode} requestErrorText={requestErrorText} reloadAddress={getUrlPrefix(language) + "blog"}></SectionLoadingError>
                    </>
                    : 
                    <></>
                }
                { isLoaded ?
                    <div className="bg-white mb-5">
                        <div className="article-hero-section navbar-size-compensation">
                            {/*<div className="pt-3 pt-lg-5"></div>*/}
                            <div className="pt-3 pb-3 pt-lg-5 pb-lg-5">
                                <h1 className="text-center font-divelit-lemon mb-0">#{tag}</h1>

                            </div>
                        </div>

                        <Container id="articleContainer">
                            {taggedArticles.map((item: any,index: number) => (
                                    <>
                                    {((index % 2 === 0) ?
                                        (
                                            <>
                                                <BlogOlderStart data={item} color={determineColor(index)}></BlogOlderStart>
                                            </>
                                        )
                                        :
                                        (
                                            <>
                                                <BlogOlderEnd data={item} color={determineColor(index)}></BlogOlderEnd>
                                            </>
                                        )
                                    )}
                                    </>
                                    )) 
                                }
                        </Container>
                    </div>
                :
                <></>
                }
            </div>
        </>
    );
}
